module.exports = __webpack_public_path__ + "img/new4-1.b6a1bf20.gif";